import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDroobleComponent } from './simple-icons-drooble.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDroobleComponent ],
    exports:      [ SimpleIconsDroobleComponent ],
    bootstrap:    []
})
export class SimpleIconsDroobleModule {}
